module.exports = __webpack_public_path__ + "img/logo.ce74425f.png";